import { OrderTransactionEndpoint } from "@api/endpoints/OrderTransactionEndpoint";
import { QueryUtil } from "../Query";
import { Client } from "./Client";

export class OrderTransactionsApi {
  static getOrder (
    id: string,
    accessToken?: string,
  ): Promise<OrderTransactionEndpoint.Get.Response> {
    const query = accessToken ? `accessToken=${accessToken}` : '';
    return Client(`orders/${id}?${query}`);
  }
  static getLatestProcessedOrderDate (
    query: OrderTransactionEndpoint.GetLatestProcessedOrderDate.Query,
  ): Promise<OrderTransactionEndpoint.GetLatestProcessedOrderDate.Response> {
    if (query) {
      return Client(`orders/latest-processed-order-date?${QueryUtil.stringify(query)}`);
    }
    return Client('orders/latest-processed-order-date');
  }
  static list (
    query: OrderTransactionEndpoint.List.Query,
  ): Promise<OrderTransactionEndpoint.List.Response> {
    if (query.orderSubtype === null) {
      query.orderSubtype = 'null';
    }
    return Client(`orders?${QueryUtil.stringify(query)}`);
  }
  static listBookingsByFarmerId (
    farmerId: string,
  ): Promise<OrderTransactionEndpoint.ListBookingsByFarmerId.Response> {
    const url = `bookings/farmer/${farmerId}`;
    return Client(url);
  }
  static listBookingsByRetailer (
    body: OrderTransactionEndpoint.ListBookings.Query,
  ): Promise<OrderTransactionEndpoint.ListBookings.Response> {
    return Client('bookings', {
      method: 'POST',
      body,
    });
  }

  static hasTransactionSubtypes (
    query: OrderTransactionEndpoint.HasTransactionSubtypes.Query,
  ): Promise<OrderTransactionEndpoint.HasTransactionSubtypes.Response> {
    return Client(`orders/has-transaction-subtypes?${QueryUtil.stringify(query)}`);
  }
}
